// Shared conversion tracking for waitlist signups (Google Analytics + Meta Pixel).
export function trackWaitlistLead(eventLabel, contentName) {
  if (window.gtag) {
    window.gtag("event", "waitlist_signup", {
      event_category: "engagement",
      event_label: eventLabel,
      value: 1,
    });
  }
  if (window.fbq) {
    window.fbq("track", "Lead", { content_name: contentName });
  }
}
